<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';
    import ButtonMain from '../ButtonMain.svelte';
    import { features, fm } from './features';
    import Switch from '../Switch.svelte';
    import AvailableFeaturesList from './AvailableFeaturesList.svelte';

    export let isOpen: boolean = false;
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents">
            <!--            features:{$fm.getActiveFeaturesList().join(',')}-->
            <!--            features:{JSON.stringify($features)}-->
            <h3 style="text-align: center;">Select features</h3>
            <div
                style="display: flex; row-gap: 8px; flex-direction: column; max-height: 450px; overflow: auto;"
            >
                <AvailableFeaturesList />
            </div>
            <div class="actions">
                <ButtonMain
                    text={$_('OK')}
                    on:click={() => {
                        closeModal();
                    }}
                />
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        width: 590px;
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        pointer-events: auto;
        font-size: 14px;
        padding: 30px;
        border: 3px solid var(--automapa-blue);
        box-shadow:
            0 0 0 10px #1c5dc722,
            0 4px 8px rgba(0, 0, 0, 0.2);
    }

    .actions {
        margin-top: 32px;
        display: flex;
        justify-content: center;
        column-gap: 10px;
    }
</style>
